//export default 'https://app.sleep-well.coach'
export default process.env.VUE_APP_FRONTEND_URL;
